declare global {
  let __sasAuthPopover: Window | undefined;
  interface globalThis {
    __sasAuthPopover: Window | undefined;
  }
}
const global: any = globalThis;
global.__sasAuthPopover = global.__sasAuthPopover || undefined;

function removeCurrentPopup() {
  const oldPopover = __sasAuthPopover;
  if (!oldPopover) {
    return;
  }
  __sasAuthPopover = undefined;
  oldPopover.close();
}

class Popup {
  protected _closed: boolean = true;
  protected _url: string;
  protected _title: string;
  popup: Window | undefined;

  constructor(url: string, title: string) {
    this._url = url;
    this._title = title;
  }

  open() {
    this._closed = this.popup ? this.popup.closed : true;
    if (__sasAuthPopover && __sasAuthPopover === this.popup && !this._closed) {
      this.popup?.focus();
      return;
    }
    const top = window.outerHeight / 2 + window.screenY - 600 / 2;
    const left = window.outerWidth / 2 + window.screenX - 700 / 2;
    const popup = window.open(
      this._url,
      this._title,
      `width=700,height=600,top=${top},left=${left}`
    );
    if (popup && !popup.closed) {
      this._closed = false;
      this.popup = popup;
      __sasAuthPopover = popup;
    }
  }

  close() {
    if (__sasAuthPopover === this.popup) {
      removeCurrentPopup();
    }
  }
}

class PopupWithMessage extends Popup {
  private _resolve: undefined | (() => void);
  private _reject: undefined | (() => void);
  private _resolutionPromise: Promise<void> | undefined;
  private _intervalId: number | undefined;
  private _messageCb: ((event: MessageEvent) => void) | undefined;

  private _rejectPromise() {
    if (!this._resolutionPromise) {
      return;
    }
    if (this._messageCb) {
      window.removeEventListener('message', this._messageCb);
    }
    clearInterval(this._intervalId);
    this._messageCb = undefined;
    this._resolutionPromise = undefined;
    this._resolve = undefined;
    this._reject?.();
    this._reject = undefined;
  }

  private _acceptPromise() {
    if (!this._resolutionPromise) {
      return;
    }
    if (this._messageCb) {
      window.removeEventListener('message', this._messageCb);
    }
    clearInterval(this._intervalId);
    this._messageCb = undefined;
    this._resolutionPromise = undefined;
    this._reject = undefined;
    this._resolve?.();
    this._resolve = undefined;
  }

  open() {
    super.open();
    if (!this._closed) {
      this._resolutionPromise = new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
        this._messageCb = (event: MessageEvent) => {
          if (this._url.indexOf(event.origin) !== -1 && event.data && event.data.logonStatus) {
            this._acceptPromise();
          }
        };
        window.addEventListener('message', this._messageCb);
        this._intervalId = window.setInterval(() => {
          this.popup?.postMessage('register', '*');
        }, 250);
      });
    }
  }

  waitForMessage(): Promise<void> {
    if (this._resolutionPromise) {
      return this._resolutionPromise;
    }
    return Promise.reject();
  }

  close() {
    super.close();
    this._rejectPromise();
  }
}

export function openMessagePopup(location: string, title: string) {
  const popup = new PopupWithMessage(location, title);
  popup.open();
  return popup.waitForMessage().then(() => popup.close());
}
